import { Box, ButtonGroup } from '@mui/material';
import { HowToUploadView } from './HowToUploadView';
import { FileTypesView } from './FileTypesView';
import { AssemblyGuidelinesView } from './AssemblyGuidelinesView';
import { ExpandableItem } from './ExpandableItem';
import { StyledHelpViewButton } from './StyledHelpButton';

export enum UploadView {
  HowToUpload = 'howToUpload',
  FileTypes = 'fileTypes',
  AssemblyGuidelines = 'assemblyGuidelines',
}

export const AssetsUploadView = ({
  isOpen,
  onToggle,
  viewParameter,
  setUploadView,
}: {
  isOpen: boolean;
  onToggle: () => void;
  viewParameter: UploadView | null;
  setUploadView: (view: string) => () => void;
}) => {
  const currentView = viewParameter ?? UploadView.HowToUpload;

  return (
    <ExpandableItem
      isOpen={isOpen}
      onToggle={onToggle}
      title={<>3. Uploading and indexing parts and assemblies</>}
      description={
        <>
          <Box sx={{ marginBottom: '12px' }}>
            <ButtonGroup size='small' variant='outlined'>
              <StyledHelpViewButton
                onClick={setUploadView(UploadView.HowToUpload)}
                variant={currentView === UploadView.HowToUpload ? 'contained' : 'outlined'}
              >
                Uploading
              </StyledHelpViewButton>
              <StyledHelpViewButton
                onClick={setUploadView(UploadView.FileTypes)}
                variant={currentView === UploadView.FileTypes ? 'contained' : 'outlined'}
              >
                Supported file types
              </StyledHelpViewButton>
              <StyledHelpViewButton
                onClick={setUploadView(UploadView.AssemblyGuidelines)}
                variant={currentView === UploadView.AssemblyGuidelines ? 'contained' : 'outlined'}
              >
                Assembly guidelines
              </StyledHelpViewButton>
            </ButtonGroup>
          </Box>
          {currentView === UploadView.HowToUpload && <HowToUploadView />}
          {viewParameter === UploadView.FileTypes && <FileTypesView />}
          {viewParameter === UploadView.AssemblyGuidelines && <AssemblyGuidelinesView />}
        </>
      }
    />
  );
};
